/* eslint-disable jsx-a11y/anchor-has-content */
import * as React from 'react';
import infoCircle from '../../assets/img/info-circle.svg';
import '../../styles/App.css';
import { withStyles } from "@material-ui/styles";
import { Tooltip } from "@material-ui/core";


export default function HeaderLine() {
  return (
      <div className="tooltip-parent">
        <div className="headerLine">
        <div className="headerContent">
          <Tooltip 
          title={<div><div className="overlay-arrow"></div> <div class="hover-title">Kostenlos aus allen Netzen</div>
          <div>Mo-Fr: 08-22 Uhr, Sa-So: 09-17 Uhr</div>
          <div class="hover-info">Datenschutzhinweise zu <a href='https://www.vodafone.de/unternehmen/soziale-verantwortung/datenschutz-online.html?icmp=info:datenschutz' target='blank'>
           Rufnummem</a></div></div>}
          placement="bottom-end"
          >
            <div>
            <div></div>
          <div>Beratung & Bestellung: 0800 444066 0484<img className="info" src={infoCircle} alt={'info icon'}/></div></div>
          </Tooltip>     
        </div>
        </div>
        </div>
      )
}